import React, { useContext, useEffect, useState } from 'react';
import styled from 'styled-components';
import { featureEnabled } from 'utils';
import { InputTextArea, message } from 'components';
import saveUserAdminNotes from 'api/UserAdminNotesController/saveUserAdminNotes';
import { Section, SectionTitle } from '../styles';
import MLSUserPageContext from '../MLSUserPageContext';

const NotesSection: React.FC = () => {
  const { loading, user, notes, setNotes } = useContext(MLSUserPageContext);
  const [debouncedNotes, setDebouncedNotes] = useState<string | null>(null);
  const [hasUserEdited, setHasUserEdited] = useState(false);

  useEffect(() => {
    if (!user || !hasUserEdited || debouncedNotes === null) return;

    const saveNotes = async () => {
      try {
        await saveUserAdminNotes({
          userId: user.id,
          adminNotes: debouncedNotes,
        });
        message.success('Admin notes saved');
      } catch (error) {
        message.error('Error saving admin notes');
      }
    };

    saveNotes();
  }, [debouncedNotes, user, hasUserEdited]);

  useEffect(() => {
    if (!user || !hasUserEdited) return;

    const handler = setTimeout(() => {
      setDebouncedNotes(notes);
    }, 2000);

    return () => {
      clearTimeout(handler);
    };
  }, [notes, user, hasUserEdited]);

  if (!featureEnabled('supraAutoCoopFeature')) return null;

  return (
    <Section data-cy="auto-coop-notes-section">
      <Container>
        <SectionTitle>Admin Notes</SectionTitle>
        <StyledTextArea
          placeholder="Click to add a note"
          disabled={loading}
          maxLength={500}
          showCount
          value={notes}
          onChange={e => {
            setNotes(e.target.value);
            setHasUserEdited(true);
          }}
        />
      </Container>
    </Section>
  );
};

export default NotesSection;

const Container = styled.div`
  padding: 16px;
`;

const StyledTextArea = styled(InputTextArea)`
  > .ant-input-textarea > textarea {
    height: 150px;
  }
`;
